// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__27Eu_","choiceBoxes":"toolbarselects_choiceBoxes__39nTy","simpleField":"toolbarselects_simpleField__2VV24"};